import React from 'react';


const AppLayoutTitle = ({ title, buttons }) =>
    <div className="d-flex justify-content-between align-items-center border-bottom px-3 py-2 flex-row">
        <h5 className='p-0 m-0'>{title}</h5>
        {buttons && <div>{buttons}</div>}
    </div>
export default AppLayoutTitle;